class MFRLogoBar {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      marquee: ".logo-bar__marquee",
      control: ".logo-bar__control-button",
      helper: ".logo-bar__marquee-helper",
      entry: ".logo-bar__marquee-entry"
    };

    this.init();
  }

  init() {
    this.$marquee = this.$element.find(this.selectors.marquee);
    this.$control = this.$element.find(this.selectors.control);
    this.$helper  = this.$element.find(this.selectors.helper);
    this.$entry   = this.$element.find(this.selectors.entry);

    this.$control.on("click", this.__handleControlClick.bind(this));

    window.onWidthResize(this.__handleWidthResize.bind(this));
    this.__handleWidthResize();
  }

  __handleControlClick(e) {
    this.$marquee.removeClass( "play pause" );

    if (this.$control.hasClass("pause"))
      this.$marquee.addClass("pause");
  }

  __handleWidthResize(e) {
    const maxWidth = this.$helper.width();
    this.$entry.css( "min-width", maxWidth );
  }
}